export enum AutoriteFourriereSortOptions {
  'DEPARTEMENT' = 'DEPARTEMENT',
  'TYPE' = 'TYPE',
  'LIBELLE' = 'LIBELLE',
  'CODE_POSTAL' = 'CODE_POSTAL',
  'VILLE' = 'VILLE',
}
